import dayjs from 'dayjs'

export const formatDate = (date, format) => {
    const newDate = new Date(date)
    // 'DD/MM/YYYY HH:mm'
    
    return dayjs(newDate).format(format)
}